import {formatTimeByFrame, toRupiah} from '../../../functions/general'
import {IComponent} from '../../../interfaces/Analytics/Analytics'
interface IProps {
  component: IComponent
}
const SummaryWidget = ({component}: IProps) => {
  const mergedData: any[] = []
  component.dataCore.forEach((core) => {
    core.data.forEach((entry) => {
      let existing = mergedData.find((item) => item.time === entry.time)
      if (!existing) {
        existing = {time: entry.time}
        mergedData.push(existing)
      }
      existing['value'] = entry.value
    })
  })
  let total = mergedData.reduce((acc, cur) => (acc += cur.value), 0)

  return (
    <div style={{position: 'relative'}}>
      <div className='my-3 position-relative'>
        <div
          className='d-flex justify-content-between text-white flex-column mt-6'
          style={{left: '8px'}}
        >
          <div
            className={`d-flex card-title   d-block gap-3 font-weight-bold display-6`}
          >
            Total
          </div>
          <div className='display-6'>
            {component.dataType === 'NOMINAL' ? toRupiah(total) : total}
          </div>
        </div>

        <div className='d-flex   text-white overflow-auto' style={{gap: '36px'}}>
          {mergedData.map((data: any) => {
            return (
              <div className='d-flex flex-column py-6'>
                <div className='text-nowrap'>
                {formatTimeByFrame(data.time, component.timeFrame)}
                </div>
                <span className='text-white fs-1 me-2' style={{fontWeight: '700'}}>
                  {component.dataType === 'NOMINAL' ? toRupiah(data.value) : data.value}
                </span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default SummaryWidget
